<template>    
    <v-dialog
      v-model="dialog"
      width="500"
    >      
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
            Información Adicional            
        </v-card-title>
        
        <v-layout wrap align-center>
            <!--v-flex xs10 offset-xs1>                
                <v-text-field v-model="codIntCliente" label="Cód. Interno Cliente"></v-text-field>
            </v-flex-->   
            <v-flex xs10 offset-xs1>
                <v-autocomplete
                    v-model="codIntCliente"
                    :items="codsIntClientes"
                    item-text="no"
                    item-value="no"
                    dense
                    filled
                    label="Cód. Interno Cliente"
                    clearable
                ></v-autocomplete>
            </v-flex>  
                          
            <v-flex xs10 offset-xs1>                
                <v-autocomplete
                    v-model="origen"
                    :items="origenes"
                    item-text="no"
                    item-value="no"
                    dense
                    filled
                    label="Origen"
                    clearable
                ></v-autocomplete>
            </v-flex> 
            <v-flex xs10 offset-xs1>                
                <v-autocomplete
                    v-model="destino"
                    :items="destinos"
                    item-text="no"
                    item-value="no"
                    dense
                    filled
                    label="Destino"
                    clearable
                ></v-autocomplete>
            </v-flex>   
            <v-flex xs10 offset-xs1>
                <!--v-select-->
                <v-autocomplete
                v-model="resourcesAditional"
                :items="resourcesFiltered"
                :item-text="resourceLabel"
                item-value="no"
                dense
                filled
                label="Recursos adicionales"
                clearable
                multiple
                chips
                hint="Seleccione otros recursos (opcional)"
                persistent-hint
                @change="validateResourceChange"
                ></v-autocomplete>
            </v-flex>
            <v-flex xs10 offset-xs1>                
                <v-autocomplete
                    v-model="residuo"
                    :items="residuos"
                    item-text="desc"
                    item-value="no"
                    dense
                    filled
                    label="Residuos"
                    clearable
                ></v-autocomplete>
            </v-flex>    
            <v-flex xs10 offset-xs1>                
                <v-text-field autocomplete="off" v-model="otroResiduo" label="Otro Residuo" @keyup="checkLengthRes(250)"></v-text-field>
            </v-flex>    
            <v-flex xs10 offset-xs1>   
                <v-textarea
                v-model="taskDescription"
                autocomplete="off"
                @keyup="checkLength(250)"
                >
                <template v-slot:label>
                    <div>
                    Descripción de la tarea <small>(obligatorio)</small>
                    </div>
                </template>
                </v-textarea>  
            </v-flex>          
        </v-layout>                
        
        <v-divider></v-divider>

        <v-card-actions>
            <!--v-btn
                color="primary"
                text
                @click="close"
            >
                Cancelar
            </v-btn-->
            <v-spacer></v-spacer>          
            <v-btn
                color="primary"
                text
                @click="closeOK"
            >
                Aceptar
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>  
</template>
<script>
export default {
    name: 'dialogExtraInfo',
    data () {
      return {    
          resourcesFiltered: [],
          resourcesAditionalBackup: []    
      }
    },
    methods:{ 
        resourceLabel(res){
            return res.no + " - " + res.name;
        },       
        close(){
            this.$store.commit('saveCodIntCliente','');
            this.$store.commit('saveOrigen','');
            this.$store.commit('saveDestino','');
            this.$store.commit('saveResiduo','');
            this.$store.commit('saveTaskDescription','');
            this.$store.commit('saveResourcesAditional',[]);
            this.dialog = false;                        
        },
        closeOK(){            
            this.dialog = false;                        
        },
        validateResourceChange(){
            if (this.$store.state.parteDetalleObject && this.resourcesAditionalBackup.length > this.resourcesAditional.length){
                alert('No se pueden eliminar recursos adicionales de un parte ya recibido en NAV. Consulte con administración')
            }
        },
        checkLength(max){
            if (this.taskDescription.length > max){
                this.taskDescription = this.taskDescription.slice(0,max);
            }
        },
        checkLengthRes(max){
            if (this.otroResiduo.length > max){
                this.otroResiduo = this.otroResiduo.slice(0,max);
            }
        }
    },
    created(){
    },
    mounted(){
        
    },
    watch:{
        residuo: function(val){
            if (val != ''){
                this.otroResiduo = '';
            }
        },
        otroResiduo: function(val){
            if (val != ''){
                this.residuo = '';
            }
        },
        dialog: function(val){
            if (val){          
                this.getOrigenes(this.$store.state.proyecto);
                this.getDestinos();
                this.getResiduos();   
                this.getCodInternos();        
                this.getResources(); 
                if (this.$store.state.parteDetalleObject && this.$store.state.parteDetalleObject.resourcesAditional && (this.$store.state.parteDetalleObject.resourcesAditional.length > 0)){
                    this.$store.commit('saveResourcesAditional',this.$store.state.parteDetalleObject.resourcesAditional);
                    this.resourcesAditionalBackup = JSON.parse(JSON.stringify(this.$store.state.parteDetalleObject.resourcesAditional));
                }
            }
        },
        resources: function(val){
            if (val.length > 0){
                this.resourcesFiltered = JSON.parse(JSON.stringify(val));
                this.resourcesFiltered = this.resourcesFiltered.filter(res =>{
                    return (res.aditional == '1');
                });  
                var index = -1;
                for (var i = 0; i < this.resourcesFiltered.length; i++){
                    if (this.resourcesFiltered[i].no == this.$store.state.resource)
                        index = i;
                }
                console.log(this.resourcesFiltered);
                if (index > -1)
                    this.resourcesFiltered.splice(index,1);
                console.log(this.resourcesFiltered);
            }
        },
        resourcesAditional: function(val){
            if (this.$store.state.parteDetalleObject && this.resourcesAditionalBackup.length > val.length){
                this.resourcesAditional = this.resourcesAditionalBackup;
            }
        }
    },
    computed:{
        dialog: {
            get(){
                return this.$store.state.dialogExtraInfo;
            },
            set(value){
                this.$store.state.dialogExtraInfo = value;
            }
        },
        codsIntClientes:{
            get(){
                return this.$store.state.codsIntClientes;
            }
        },
        codIntCliente:{
            get(){
                return this.$store.state.codIntCliente;
            },
            set(value){                
                this.$store.commit('saveCodIntCliente',value);
            }
        },
        taskDescription:{
            get(){
                return this.$store.state.taskDescription;
            },
            set(value){                
                this.$store.commit('saveTaskDescription',value);
            }
        },
        origenes:{
            get(){
                return this.$store.state.origenes;
            }
        },
        origen:{
            get(){
                return this.$store.state.origen;
            },
            set(value){                
                this.$store.commit('saveOrigen',value);
            }
        },
        destinos:{
            get(){
                return this.$store.state.destinos;
            }
        },
        destino:{
            get(){
                return this.$store.state.destino;
            },
            set(value){                
                this.$store.commit('saveDestino',value);
            }
        },
        residuos:{
            get(){
                return this.$store.state.residuos;
            }
        },
        residuo:{
            get(){
                return this.$store.state.residuo;
            },
            set(value){                
                this.$store.commit('saveResiduo',value);
            }
        },
        otroResiduo:{
            get(){
                return this.$store.state.otroResiduo;
            },
            set(value){                
                this.$store.commit('saveOtroResiduo',value);
            }
        },
        resources:{
            get(){
                return this.$store.state.resources;
            },
            /*set(value){                
                this.$store.commit('saverResources',value);
            }*/
        },
        resourcesAditional:{
            get(){
                return this.$store.state.resourcesAditional;
            },
            set(value){                
                this.$store.commit('saveResourcesAditional',value);
            }
        }
    }
}
</script>

